import { css } from 'styled-components';

type CSSArgs = Parameters<typeof css>;
type CSSReturn = ReturnType<typeof css>;

type ScreenSizes = {
  [key: string]: string;
};

export const deviceSize = {
  mobile: 900,
  desktop: 1350,
  desktopLarge: 1440,
  desktopLargeMax: 3199,
  desktopLarge4K: 3200,
};

const device: ScreenSizes = {
  mobile: `${deviceSize.mobile}px`,
  desktop: `${deviceSize.desktop}px`,
  desktopLarge: `${deviceSize.desktopLarge}px`,
  desktopLargeMax: `${deviceSize.desktopLargeMax}px`,
  desktopLarge4K: `${deviceSize.desktopLarge4K}px`,
};

const breakpoints = {
  mobile: (...args: CSSArgs): CSSReturn => css`
    @media (max-width: ${device.mobile}) {
      ${css(...args)}
    }
  `,
  desktop: (...args: CSSArgs): CSSReturn => css`
    @media (min-width: ${device.mobile}) and (max-width: ${device.desktopLarge}) {
      ${css(...args)}
    }
  `, desktopLarge: (...args: CSSArgs): CSSReturn => css`
    @media (min-width: ${device.desktopLarge}) and (max-width: ${device.desktopLargeMax}) {
      ${css(...args)}
    }
  `,
  desktopLarge4K: (...args: CSSArgs): CSSReturn => css`
    @media (min-width: ${device.desktopLarge4K}) {
      ${css(...args)}
    }
  `,
};

export default breakpoints;
